import Hero from '../components/Hero'
import DeviceShowcase from '../components/DeviceShowcase'
import Services from '../components/Services'
import About from '../components/About'
import Solutions from '../components/Solutions'
import Pricing from '../components/Pricing'
import FAQ from '../components/FAQ'
import Contact from '../components/Contact'
import Products from '../components/Products'
import { hideProducts } from '../config/featureFlags'

const HomePage = () => {
  return (
    <main className="w-full min-w-0" role="main" id="main-content" tabIndex={-1}>
      <Hero />
      <DeviceShowcase />
      <Services />
      <About />
      <Solutions />
      {!hideProducts && <Products />}
      <Pricing />
      <FAQ />
      <Contact />
    </main>
  )
}

export default HomePage

